import { BottomButtonsLayout } from 'aimo-ui';
import React, { useEffect } from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import styled from 'styled-components/native';
import { ParkingLayoutProps } from 'types/common';
import ParkingWizardFooterSwitch from './shortTermParkingWizard/ParkingWizardFooterSwitch';

type ParkingLayoutFullScreenProps = {
  component: React.FC<
    ParkingLayoutProps & { withLTP?: boolean; isTesting?: boolean }
  >;
  withPadding?: boolean;
  scrollable?: boolean;
};

const ParkingContentWrapper = styled.View<{ withPadding?: boolean }>`
  flex: 1;
  padding: 10px ${(p) => (p.withPadding ? '20' : '0')}px 0px;
`;

const ParkingLayoutFullScreen = ({
  component: Component,
  currentScreen,
  withPadding,
  scrollable = true,
}: ParkingLayoutFullScreenProps & ParkingLayoutProps) => {
  const scrollViewRef = React.useRef<ScrollView | null>(null);

  // Flash scroll to indicate scrolling content
  useEffect(() => {
    const intervalId = setInterval(
      () => scrollViewRef.current?.flashScrollIndicators(),
      10000
    );
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <BottomButtonsLayout
      scrollable={scrollable}
      scrollViewRef={scrollViewRef}
      contentBottom={
        <ParkingWizardFooterSwitch currentScreen={currentScreen} />
      }>
      <ParkingContentWrapper withPadding={withPadding}>
        <Component />
      </ParkingContentWrapper>
    </BottomButtonsLayout>
  );
};

export default React.memo(ParkingLayoutFullScreen);
